define('shared/initializer/form/adapters/mixins/AdyenSwitchable',[
    'Promise',
    'shared/lib/URI',
    'shared/page/wcmmode',
    'shared/remote/payment/adyen/getStoredTokens'
],
function (
    Promise,
    URI,
    getWCMMode,
    getStoredTokens
) {
    'use strict';

    var uri = new URI(location.href);
    var searchParameters = uri.query(true);
    var ADYEN_GATEWAY_NAME = 'AdyenEL'

    function Ctor() {}

    Ctor.getSubElements = function (form) {
        if (form._adyenSwitchableSubElements) {
            return form._adyenSwitchableSubElements;
        }

        var $form = form.$form;
        var $paymentStored = $form.find('.payment-stored');
        var $paymentStoredSubmit = $paymentStored.find('.submit');
        var $paymentNew = $form.find('.payment-new');
        var $adyenContainer = $paymentNew.find('.adyen-container');
        var $paymentNewHeadup = $paymentNew.find('.headup');

        form._adyenSwitchableSubElements = {
            storedPayment: {
                $wrapper: $paymentStored,
                $submit: $paymentStoredSubmit
            },
            newPayment: {
                $wrapper: $paymentNew,
                $adyenContainer: $adyenContainer,
                $headup: $paymentNewHeadup
            }
        };

        return form._adyenSwitchableSubElements;
    };

    function switchToStoredPayment(form) {
        var subEls = Ctor.getSubElements(form);
        
        subEls.storedPayment.$wrapper.show();
        subEls.newPayment.$wrapper.hide();
    }

    function switchToNewPayment(form) {
        var subEls = Ctor.getSubElements(form);

        subEls.storedPayment.$wrapper.hide();
        subEls.newPayment.$wrapper.show();
    }

    function resumeToPaymentForm(form) {
        switchToNewPayment(form);
        form.emit('mixin.switchable.switch', 'b');
    }

    function addBackgroundCardIcon($form, cardType) {
        var cardIcon = $form.find('.icon-card');
        if (cardIcon.length < 1) {
            return;
        }
        cardIcon.css(
            'background-image', 
            'url(https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/' + 
                cardType + 
                '.svg)'
        );
    }

    function addTokenTextToHtml($form, tokenText) {
        var tokenValue = $form.find('.token-value');
        if (tokenValue.length < 1 || !tokenText) {
            return;
        }
        tokenValue.text('•••• ' + tokenText.slice(-4));
    }

    function checkStoredTokensAndSwitchUI(form) {
        return getStoredTokens()
            .then(null, function() {
                return null;
            })
            .then(function(res){
                if (!res || !res.hasToken || res.gatewayType !== ADYEN_GATEWAY_NAME) {
                    resumeToPaymentForm(form);
                    return;
                }
                
                addBackgroundCardIcon(form.$form, res.gatewayCardType);
                addTokenTextToHtml(form.$form, res.accountNumber);
                form
                    .$form
                    .find('.add-new-card')
                    .click(function(){
                        resumeToPaymentForm(form);
                    });
            });
    }

    Ctor.prototype.doPageLoad = function() {
        var form = this;
        /*
        * Temporary switch to allow releasing Adyen
        * stored-payment functionality selectively to markets
        */
        if (form.options.disableAdyenStoredPayment) {
            resumeToPaymentForm(form);
            return;
        }

        switchToStoredPayment(form);
        
        return getWCMMode()
            .then(function(wcmmode) {
                if (wcmmode !== 'disabled') {
                    return;
                }

                if (searchParameters.resultCode) {
                    resumeToPaymentForm(form);
                    return;
                }

                return checkStoredTokensAndSwitchUI(form);
            });
    };

    return Ctor;
    
});
